import { CONFIGURATIONS } from "../config/envConfig";

// create google OAuth url with scopes for redirect user to google concent screen
export const getGoogleAuthUrl = () => {

    const googleClentId = CONFIGURATIONS.GOOGLE_CLIENT_ID;
    const googleRedirectUrl = CONFIGURATIONS.GOOGLE_REDIRECT_URL;
    const googelScopes = ['email' , 'profile'];
    const baseUrl = 'https://accounts.google.com/o/oauth2/v2/auth';

    const params = new URLSearchParams(
        {
            client_id: googleClentId,
            redirect_uri: googleRedirectUrl,
            response_type: 'code',
            scope: googelScopes.join(" ")
        }
    )

    if(!googleClentId || !googleRedirectUrl){
        
        return null;
    }
    
   const authUrl = `${baseUrl}?${params.toString()}`;
   return authUrl;
}